import React from "react";
import './KanziFadeTitle.css';

const KanziFadeTitle = () => {
    return (
      <div className="KCT-fade-images-container">
        <img src="KanziCelebration/KanziShadowText.png" alt="Image 1" className="KCT-fade-img img1" />
        <img src="KanziCelebration/KanziShadowSymbol.png" alt="Image 2" className="KCT-fade-img img2" />
        <img src="KanziCelebration/BonoboSapien.png" alt="Image 3" className="KCT-fade-img img3" />
      </div>
    );
  };

export default KanziFadeTitle;